<div class="p-grid">
  <div class="p-col-12 p-lg-4 p-g-nopad">
    <div class="mail-form full-width no-margin">
      <div class="p-col-12">
        <app-invoice-crediflow-status
          [invoiceId]="invoiceId"
        ></app-invoice-crediflow-status>

        <div class="column-title">
          <h4>Bifoga filer</h4>
        </div>
        <div *ngFor="let attachment of attachments | async">
          <p-checkbox
            [binary]="true"
            [ngModel]="attachment.checked"
            [ngModelOptions]="{ standalone: true }"
            (onChange)="toggleAttachment(attachment)"
            [label]="attachment.name"
            class="p-mb-1"
          ></p-checkbox>
        </div>
      </div>
      <div class="p-col-12">
        <button
          pButton
          class="p-button-primary-hyperion"
          [disabled]="isLoading"
          (click)="send()"
          icon="pi pi-send"
          label="Skicka e-faktura"
        ></button>

        <button
          pButton
          type="button"
          class="p-button-secondary-hyperion p-ml-2"
          [disabled]="!invoiceId"
          (click)="openMailDialog()"
          icon="pi pi-envelope"
          label="Skicka med e-post"
        ></button>
      </div>
    </div>
  </div>

  <div class="p-col-12 p-lg-8">
    <h3>Förhandsgranska bifogade PDF-filer</h3>
    <spinner *ngIf="previewIsLoading"></spinner>
    <div *ngIf="previewUrl" class="pdf-container">
      <iframe
        (load)="onPreviewLoaded()"
        [hidden]="previewIsLoading"
        [attr.src]="previewUrl"
        style="width: 100%"
        class="pdf-view-object"
        frameborder="0"
        scrolling="no"
      >
        <p>
          Kan inte läsa pdf i webbläsaren.
          <a [href]="previewUrl" target="_blank"
            >Tryck här för att ladda ned.</a
          >
        </p>
      </iframe>
    </div>
  </div>
</div>
